import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
} from "helpers/api_helper"
import {
  ADD_MODIFIER_GROUP,
  DELETE_MODIFIER_GROUP,
  GET_ALL_MODIFIER_GROUPS,
  GET_ALL_MODIFIER_GROUPS_LIST,
  GET_MODIFIER_GROUP_DETAILS,
  UPDATE_MODIFIER_GROUP,
  UPDATE_MODIFIER_GROUP_STATUS,
} from "helpers/url_helper"

export const getAllModifierGroups = createAsyncThunk(
  GET_ALL_MODIFIER_GROUPS,
  async payload => {
    const response = await post(GET_ALL_MODIFIER_GROUPS, payload)
    return response
  }
)

export const getAllModifierGroupsList = createAsyncThunk(
  GET_ALL_MODIFIER_GROUPS_LIST,
  async ({ countryCode }) => {
    const response = await get(
      `${GET_ALL_MODIFIER_GROUPS_LIST}?countryCode=${countryCode}`
    )
    return response
  }
)

export const addModifierGroups = createAsyncThunk(
  ADD_MODIFIER_GROUP,
  async payload => {
    const response = await formDataPost(ADD_MODIFIER_GROUP, payload)
    return response
  }
)

export const deleteModifierGroup = createAsyncThunk(
  DELETE_MODIFIER_GROUP,
  async payload => {
    const response = await del(DELETE_MODIFIER_GROUP, payload)
    return response
  }
)

export const getModifierGroupDetails = createAsyncThunk(
  GET_MODIFIER_GROUP_DETAILS,
  async payload => {
    const response = await post(GET_MODIFIER_GROUP_DETAILS, payload)
    return response
  }
)

export const updateModifierGroups = createAsyncThunk(
  UPDATE_MODIFIER_GROUP,
  async payload => {
    const response = await formDataPut(UPDATE_MODIFIER_GROUP, payload)
    return response
  }
)

export const updateModifierGroupStatus = createAsyncThunk(
  UPDATE_MODIFIER_GROUP_STATUS,
  async payload => {
    const response = await patch(UPDATE_MODIFIER_GROUP_STATUS, payload)
    return response
  }
)

export const deleteModifierGroupForAll = createAsyncThunk(
  "DELETE_MODIFIER_GROUP",
  async payload => {
    const response = await del(DELETE_MODIFIER_GROUP, payload)
    return response
  }
)
